import { GetterTree } from "vuex";
import { RootState } from "../types";
import { MapState } from "./types";

export const getters: GetterTree<MapState, RootState> = {
};
